/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FormateurClasseSearch
 */
export interface FormateurClasseSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurClasseSearch
     */
    idformateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FormateurClasseSearch
     */
    idclasse?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurClasseSearch
     */
    codeClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurClasseSearch
     */
    nomClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurClasseSearch
     */
    codeMatiere?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurClasseSearch
     */
    nomMatiere?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof FormateurClasseSearch
     */
    dateDebut?: DateSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof FormateurClasseSearch
     */
    dateFin?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurClasseSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurClasseSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurClasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurClasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurClasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurClasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurClasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurClasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurClasseSearch interface.
 */
export function instanceOfFormateurClasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurClasseSearchFromJSON(json: any): FormateurClasseSearch {
    return FormateurClasseSearchFromJSONTyped(json, false);
}

export function FormateurClasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurClasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idclasse': !exists(json, 'idclasse') ? undefined : json['idclasse'],
        'codeClasse': !exists(json, 'codeClasse') ? undefined : TextSearchFromJSON(json['codeClasse']),
        'nomClasse': !exists(json, 'nomClasse') ? undefined : TextSearchFromJSON(json['nomClasse']),
        'codeMatiere': !exists(json, 'codeMatiere') ? undefined : TextSearchFromJSON(json['codeMatiere']),
        'nomMatiere': !exists(json, 'nomMatiere') ? undefined : TextSearchFromJSON(json['nomMatiere']),
        'dateDebut': !exists(json, 'dateDebut') ? undefined : DateSearchFromJSON(json['dateDebut']),
        'dateFin': !exists(json, 'dateFin') ? undefined : DateSearchFromJSON(json['dateFin']),
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurClasseSearchToJSON(value?: FormateurClasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateur': value.idformateur,
        'idclasse': value.idclasse,
        'codeClasse': TextSearchToJSON(value.codeClasse),
        'nomClasse': TextSearchToJSON(value.nomClasse),
        'codeMatiere': TextSearchToJSON(value.codeMatiere),
        'nomMatiere': TextSearchToJSON(value.nomMatiere),
        'dateDebut': DateSearchToJSON(value.dateDebut),
        'dateFin': DateSearchToJSON(value.dateFin),
        'centre': TextSearchToJSON(value.centre),
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

